type FormatOptions = {
	rounding?: "round" | "truncate";
	decimals?: number;
};

const format = (num: number, suffix: string, options?: FormatOptions): string => {
	const { rounding = "round", decimals = 0 } = options || {};

	let result: number;

	if (rounding === "truncate") {
		const factor = Math.pow(10, decimals);
		result = Math.floor(num * factor) / factor;
	} else {
		result = parseFloat(num.toFixed(decimals));
	}

	return `${result}${suffix}`;
};

export function formatNumberForUrl(value: number, options?: FormatOptions): string {
	if (value >= 10000000) return format(value / 10000000, "Cr", options);
	if (value >= 100000) return format(value / 100000, "L", options);
	if (value >= 1000) return format(value / 1000, "K", options);
	return value.toString();
}
